<template>
  <div class="app-chrome" v-bind:class="{ 'suspended' : isTeamSuspend, 'th' : isLangTH }">
    <loading-indicator v-if="isLoadingCurrentUser"></loading-indicator>
    <div v-else>
      <div class="alert alert-social alert-linkedin alert-suspend" v-if="isTeamSuspend">
        <div class="container-fulid">
          <h4><i class="icon md-notifications" aria-hidden="true"></i> Your Account has been suspend.
          <span class="font-size-14 p-l-10" v-if="currentUser.team.suspend.suspend_reason">{{currentUser.team.suspend.suspend_reason}}</span>
            <span class="font-size-14 p-l-10" v-else>Your credit isn't enough. Please add your credit now</span>
            <router-link
            v-bind:to="`/${$route.params.namespace}/billing#addcreditSection`"
            alt="Add credit" class="btn btn-sm btn-default" v-if="!currentUser.team.suspend.suspend_reason"> Add credit
           </router-link>
          </h4>
        </div>
      </div>
      <nav-bar></nav-bar>
      <page403 v-if="isUnauthorize"></page403>
      <router-view v-else></router-view>
      <footer class="site-footer">
        <div class="site-footer-legal">© 2017 <a href="http://byteark.com">ByteArk</a> All Rights Reserved. </div>
      </footer>
    </div>
  </div>
</template>

<script>
import { Validator } from 'vee-validate';
import moment from 'moment';
import { mapGetters } from 'vuex';
import NavBar from 'components/NavBar';
import Page403 from 'components/errors/Page403';
import LoadingIndicator from 'components/LoadingIndicator';
import StorageManager from 'src/managers/StorageManager';

export default {
  components: {
    NavBar,
    Page403,
    LoadingIndicator,
  },
  watch: {
    isLoadingCurrentUser: function() {
      this.checkAuthorize();
    },
    $route () {
      this.checkAuthorize();
    },
    currentUser: function() {
      if (this.currentUser) {
        const namespace = this.currentUser.team.namespace;

        this.$i18n.locale = this.currentUser.lang;

        Validator.setLocale(this.currentUser.lang);

        moment.locale(this.currentUser.lang);

        // check lang in local storage
        this.storage.getLang(namespace).then((lang) => {
          if (lang !== this.currentUser.lang) {
            this.storage.setLang(this.currentUser.lang, namespace);
          }
        });
      }
    },
  },
  computed: {
    ...mapGetters([
      'isLoadingCurrentUser',
      'getCurrentUserError',
      'currentUser',
    ]),
    isTeamSuspend: function() {
      if (this.currentUser) {
        if (this.currentUser.team.suspend) {
          return this.currentUser.team.suspend.is_suspend;
        }
      }
      return false;
    },
    isLangTH: function () {
      if (this.currentUser) {
        if (this.currentUser.lang === 'th') {
          return true;
        }
      }
      return false;
    },
  },
  data: function() {
    return {
      isUnauthorize: false,
      storage: null,
    };
  },
  created: function() {
    this.storage = new StorageManager();

    this.$store.dispatch('getCurrentUser');
  },
  methods: {
    checkAuthorize: function() {
      if (this.currentUser) {
        if (this.$route.matched.some(record => record.meta.requiresManager)) {
          if (this.currentUser.role !== 'manager' && !this.currentUser.team.is_superadmin) {
            //redirect 403
            // this.$router.push(`/${this.$route.params.namespace}/403`);
            this.isUnauthorize = true;
            return;
          }
        } else if (this.$route.matched.some(record => record.meta.requiresSuperAdmin)) {
          if (!this.currentUser.team.is_superadmin) {
            //redirect 403
            // this.$router.push(`/${this.$route.params.namespace}/403`);
            this.isUnauthorize = true;
            return;
          }
        } else if (this.$route.matched.some(record => record.meta.requiresReseller)) {
          if (!(this.currentUser.team.is_reseller && this.currentUser.role === 'manager')) {
            //redirect 403
            // this.$router.push(`/${this.$route.params.namespace}/403`);
            this.isUnauthorize = true;
            return;
          }
        }
      }
      this.isUnauthorize = false;
    },
  },
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// AppChrome.vue?70efabc9